// IMPORT LIBS
import Swiper from 'swiper';
import noUiSlider from 'nouislider';
import lozad from 'lozad';
import bootstrapBundle from '../../../node_modules/bootstrap/dist/js/bootstrap.bundle.js';
import "regenerator-runtime/runtime";

window.Swiper = Swiper;
window.noUiSlider = noUiSlider;
window.bootstrapBundle = bootstrapBundle;

// NEED TO USE "REQUIRE" IN THIS LIBRARY
const fancybox = require('../../../node_modules/@fancyapps/fancybox/dist/jquery.fancybox');
window.fancybox = fancybox;

// IMPORT CLASSES
import Used from './classes/Used';

// IMPORT FUNCTIONS
import { tabsCreate, tabsInit } from './functions/tabs';
import { swipersInit } from './functions/sliders';
import { accordionsCreate, controlAccordionsFilter, controlAccordionsMenu } from './functions/accordions';
import { showPartialsFixed } from './functions/partialsFixed';
import { buttonCotationBehavior, buttonFilterBehavior } from './functions/actionsForm';
import { showNavbarDropdown, showSidebarDropdown } from './functions/dropdowns';
import { sidebarFixedBehavior } from './functions/sidebarFixed';
import { controlDate } from './functions/controlDate';
import { handleSetMoreHeight } from './functions/setHeights';
import { toggleFormCaptation } from './functions/formSetup.js';


  // INIT LAZY LOADING
  const observer = lozad(); // lazy loads elements with default selector as '.lozad'
  observer.observe();

  // FUNCTIONS TO CREATE AND INIT TABS
  tabsCreate();
  tabsInit();

  // FUNCTION TO CREATE AND INIT ACCORDIONS
  accordionsCreate();

  // FUNCTION TO CREATE AND INIT SWIPERS
  swipersInit();

  // FUNCTION TO CONTROL ACCORDIONS ON USED CARS FILTER
  controlAccordionsFilter();

  controlAccordionsMenu();

  // FUNCTION TO CONTROL HEADER/FOOTER FIXED
  window.addEventListener('scroll', () => {
    showPartialsFixed('.header-fixed', 'show-header-scrolled', 'hide-header-scrolled');
    showPartialsFixed('.footer-fixed', 'show-footer-scrolled', 'hide-footer-scrolled');
    showPartialsFixed('.header-mobile.fixed', 'show-header-scrolled', 'hide-header-scrolled');

    showPartialsFixed('.header-fixed-audi', 'show-header-scrolled', 'hide-header-scrolled');
    showPartialsFixed('.header-mobile-audi', 'show-header-scrolled', 'hide-header-scrolled');
    showPartialsFixed('.header-mobile-audi.fixed', 'show-header-scrolled', 'hide-header-scrolled');
  });

  // FUNCTION TO CONTROL BEHAVIOR OF COTATION BUTTONS
  buttonCotationBehavior('.button-call-form');
  buttonCotationBehavior('.button-product-cotation');
  buttonCotationBehavior('.button-services-cotation');

  // FUNCTION TO CONTROL BEHAVIOR OF FILTERS BUTTONS
  buttonFilterBehavior('.button-call-filter');

  // FUNCTION TO CONTROL FORM'S CAPTATION LOCATION
  toggleFormCaptation($('button[data-section]'));

  // FUNCTION TO CONTROL DROPDOWNS ONLY IN NAVBARS
  showNavbarDropdown('.navbar-link.mega_menu', '.navbar-dropdown-models.modelsDropdown', 0);
  showNavbarDropdown('.navbar-link.simple', '.navbar-dropdown-list.simple', 0);

  // FUNCTION TO CONTROL DROPDOWN IN HEADER FIXED
  showNavbarDropdown('.header-link.content.mega_menu', '.navbar-dropdown-models.modelsDropdownFixed', 0);


  // FUNCTION TO CONTROL BEHAVIOR OF SIDEBAR FIXED
  sidebarFixedBehavior('.js-sidebar-button');

  // FUNCTION TO INSERT CURRENT DATE IN INPUTS [TYPE=DATE]
  controlDate('input[type="date"]');

  setTimeout(() => {
    // FUNCTION TO SET MORE HEIGHT AMONG THE ELEMENTS OF SAME TYPE
    handleSetMoreHeight('.js-promotion-name', 992);
    handleSetMoreHeight('.js-promotion-desc', 992);
    handleSetMoreHeight('.js-high-title', 992);
    handleSetMoreHeight('.js-high-desc', 992);
    handleSetMoreHeight('.js-unit-location', 768);
    handleSetMoreHeight('.js-blog-title', 992);
    handleSetMoreHeight('.js-blog-desc', 992);
  }, 500);

  setFamily();
  getModelFromParams();
  changeTestDriveImage();


  $('#categories,#order').on('change', function (event) { // catch the form's submit event
    $.ajax({ // create an AJAX call...

        data: $('#formBlog').serialize(), // get the form data
        type: $(this).attr('GET'), // GET or POST
        url: "/blog-post-page", // the file to call
        success: function (response) { // on success..
          $('#here').html(response); // update the DIV
          const observer = lozad(); // lazy loads elements with default selector as '.lozad'
          observer.observe();
          handleSetMoreHeight('.js-blog-title', 992);
          handleSetMoreHeight('.js-blog-desc', 992);
        }
    });
    return false; // cancel original event to prevent form submitting
  });

  const usedFilterData = document.querySelector('#used-filter-data');

  if(usedFilterData) {
    const dataFilter = usedFilterData.getAttribute('data-filter');
    const filters = JSON.parse(dataFilter);
    new Used(filters);
  }


function setFamily(){
  let searchParams = new URLSearchParams(window.location.search);
  const modelname = searchParams.get('modelname');
  const selector = ".my-tabs[data-content='"+modelname+"']";
}

function getModelFromParams() {
  let searchParams = new URLSearchParams(window.location.search);
  const modelname = searchParams.get('modelname');

  if (modelname) {
    $('select#model').val(modelname);
    const imgWrapper = $('form .test-drive-form-img img');

    const img = $('select#model').find('option:selected').attr('data-image');
    imgWrapper.attr('src', img);
  }
}

function changeTestDriveImage() {
  const myInput = $('select#model');
  const imgWrapper = $('form .test-drive-form-img img');
  myInput.on('change', function (e) {
    const img = $(e.target).find('option:selected').attr('data-image');
    imgWrapper.attr('src', img);
  });
}

$('.version-tabs-content').click(function() {
  var imagePath = $(this).find('.version-tabs-content-thumb').attr('src');
  $('.new-model-description-image img').attr('src', imagePath);
});


// FUNCTION TO UP TOP PAGE
$('.btn-scroll-top').on('click', function () {
  $('html,body').animate({ scrollTop: 0 }, '300')
});

//Function to controll faq collapse
$('.faq-collapse-header').on('click', function(){
  $(this).parent().toggleClass('open');
});

// FUNCTION TO ADD OVERLAY ON MODALS
function popUp(selector) {
  $('body,html').addClass('scroll-lock');
  selector.fadeIn('fast');
}

function popClose(form) {
  form ? $('.modal-form').fadeOut() : $('.modal-overlay').fadeOut();
  $('body,html').removeClass('scroll-lock');
}

// FUNCTION TO PASS INFORMATION TO POP-UP PROMOTIONS
function modalInject(data, target) {
  const { title, img, text } = data;
  $(target).find('.promotion-title').html(title);
  $(target).find('.promotion-img').attr('src', img);
  $(target).find('.promotion-text').html(text);
  popUp($(target));
}

$('.btn-open-modal').on('click', function () {
  const el = $(this).data('target');
  const data = $(this).data('json');
  data ? modalInject(data, el) : popUp($(el));
})

// FUNCTION TO OPEN MODALS
$('.modal-overlay, .btn-close-modal').on('click', function (e) {
  $(e.target).hasClass('form-close') ? popClose() : false
}).on('click', '.pop-up-content', function (event) {
  event.stopPropagation()
})

// FUNCTION TO CONTROL PAGINATIONS
let currentPage = 1;
let currentOrd = 'asc';
let order = 'id';

$('.order-control').on('click', function () {
  search(currentPage);
});

$('.page-link').on('click', function () {

  currentPage = $(this).data('page');
  $('.page-link').removeClass("active");
  $(this).addClass("active");
  search(currentPage);
});

$('.page-link').on('click', function () {
  currentPage = $(this).data('page');
  $('.page-item').removeClass("active");
  $(this.parentElement).addClass("active");

  if (currentPage != "1") {
    $('.left-arrow').removeClass("disabled");
  } else {
    $('.left-arrow').addClass("disabled");
  }

  search(currentPage);
});

function search(pageNum = 1) {
  async function busca() {
    currentOrd = $("#order").val();
    let method = $("#pageId").val();

    if(!order){
    order = 'id'
    }

    if(!currentOrd){
    currentOrd = 'asc'
    }

    if(method == 'products'){
      const result = await $.request('onGetProducts', {
      data: {order: order,direction : currentOrd, page: pageNum, limit: 1},
      complete: function(res) {
        const observer = lozad(); // lazy loads elements with default selector as '.lozad'
        observer.observe();
      }
      });
      return result;
    }

      if(method == 'promotions'){
        const result = await $.request('onGetPromotions', {
        data: {order: currentOrd,page: pageNum, limit: 9},
        complete: function(res) {
          const observer = lozad(); // lazy loads elements with default selector as '.lozad'
          observer.observe();
        }
        });
        return result;
      }

  }

  let a = busca().then( data => $("#promotions").html(data.result)).finally(
    function () {
      buttonCotationBehavior('.button-product-cotation');

      $('.btn-open-modal').on('click', function () {
        const el = $(this).data('target');
        const data = $(this).data('json');
        data ? modalInject(data, el) : popUp($(el));
      });

      $('.page-item').on('click', function () {
        const data = $(this).find('[data-page]').data('page')
        search(data);
      });
    }
  );
}
